var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.329,
    height: 47.954,
    viewBox: "0 0 35.329 47.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GPA",
    transform: "translate(10642 13362.521)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "GPA-2",
    "data-name": "GPA",
    transform: "translate(-10636.671 -13320.777)",
    fill: "#3e3e3e",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GPA")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105",
    transform: "translate(-10642 -13362.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-custom",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M20.25,22.6V15.75h3.425V22.6Z",
    transform: "translate(3.727 4.802)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M15.75,23.776V13.5h3.425V23.776Z",
    transform: "translate(1.377 3.627)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M11.25,26.126V9h3.425V26.126Z",
    transform: "translate(-0.974 1.276)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M21.8,50.2H7.925A3.428,3.428,0,0,1,4.5,46.779V5.675A3.428,3.428,0,0,1,7.925,2.25h27.4a3.428,3.428,0,0,1,3.425,3.425V33.593H35.327V5.675H7.925v41.1H21.8Z",
    transform: "translate(-4.5 -2.25)",
    fill: "#3e3e3e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpa);
export default __webpack_public_path__ + "static/media/GPA.ca77aeefa1788ff8bb5191e2bd406c37.svg";
export { ForwardRef as ReactComponent };